import { App as AntApp } from "antd"; // Import Ant Design App
import { FullLoader } from "components/FullLoader";
import { SupportWidgets } from "components/SupportWidgets";
import { useEffect, useState } from "react";
import { useAuthStore } from "store/auth.store";
import { SWRConfig } from "swr";
import { fetcher } from "utils/axios";
import { initializeChatbase } from "utils/chatbase";
import { AppRoutes } from "./Routes";

export function App() {
	const loading = useAuthStore((state) => state.loading && !state.uid);
	const [qboInProgress, setQboInProgress] = useState(false);
	const uid = useAuthStore((state) => state.uid);

	useEffect(() => {
		if (uid && !loading) {
			// User is authenticated from session storage, initialize Chatbase
			setTimeout(async () => {
				await initializeChatbase();
			}, 500); // Longer delay to ensure everything is loaded
		}
	}, [uid, loading]);

	// Monitor QBO connection status
	useEffect(() => {
		const checkQboStatus = () => {
			const inProgress = !!(window as any).__QBO_CONNECTION_IN_PROGRESS__;
			if (inProgress !== qboInProgress) {
				setQboInProgress(inProgress);
			}
		};

		// Check initially
		checkQboStatus();

		// Check periodically
		const interval = setInterval(checkQboStatus, 100);

		return () => clearInterval(interval);
	}, [qboInProgress]);

	// Dynamic SWR config based on QBO status
	const swrConfig = {
		// refreshInterval: 3000,
		loadingTimeout: 10000,
		shouldRetryOnError: true,
		errorRetryInterval: 3000,
		errorRetryCount: 2,
		fetcher,
		// Disable focus revalidation during QBO connections
		revalidateOnFocus: !qboInProgress,
		// Also disable revalidation on reconnect during QBO
		revalidateOnReconnect: !qboInProgress,
		dedupingInterval: 5000,
	};

	if (qboInProgress) {
	}

	if (loading) return <FullLoader />;

	return (
		<AntApp>
			{" "}
			{/* Wrap with Ant Design App */}
			<SWRConfig value={swrConfig}>
				<AppRoutes />
				<SupportWidgets />
			</SWRConfig>
		</AntApp>
	);
}
